import { CLASS_TYPES } from "../../common/Const";
import {
  CHARGING_LABELS,
  DURATION_LABELS,
  PARTICIPATION_LABELS,
  PAYMENT_LABELS,
} from "../products/productDisplay";

export const ENROLLMENT_STATUS_LABELS = {
  draft: "Nieaktywny",
  awaitingPayment: "Oczekuje na platnosc",
  active: "Aktywny",
  expired: "Wygasly",
  depleted: "Wyczerpany",
  cancelled: "Anulowany",
  completed: "Zakonczony",
};

const valueOrDash = value => (value === undefined || value === null || value === "" ? "-" : String(value));

export function getEnrollmentStatusLabel(status) {
  return ENROLLMENT_STATUS_LABELS[status || "draft"] || valueOrDash(status);
}

export function getClassTypeLabel(classTypeId, classTypes = CLASS_TYPES) {
  const classType = classTypes.find(item => item.id === classTypeId);
  return classType ? classType.name : valueOrDash(classTypeId);
}

export function getProductDetails(product = {}, status) {
  return {
    status: getEnrollmentStatusLabel(status),
    defaultPrice: valueOrDash(product.defaultPrice),
    paymentStrategy: PAYMENT_LABELS[product.paymentStrategy] || valueOrDash(product.paymentStrategy),
    chargingStrategy: CHARGING_LABELS[product.chargingStrategy] || valueOrDash(product.chargingStrategy),
    participationStrategy: PARTICIPATION_LABELS[product.participationStrategy] || valueOrDash(product.participationStrategy),
    packageUnits: valueOrDash(product.packageUnits),
    classType: getClassTypeLabel(product.classTypeId),
    validity: product.validForDays ? `${product.validForDays} dni` : DURATION_LABELS[product.durationPolicy] || "-",
  };
}
